<template>
  <div class="document-upload-container">
    <div @click="handleBack()">
         <HeadLable  :title="title" :goback="true" />
    </div>
    <div class="container">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <!-- <el-form-item label="文档名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入文档名称" maxlength="50" />
        </el-form-item> -->

        <!-- <el-form-item label="排序序号" prop="sort">
          <el-input-number v-model="form.sort" :min="1" :max="999" />
        </el-form-item> -->

        <el-form-item label="导入参赛选手" prop="file">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="headers"
            :on-success="handleSuccess"
            :on-error="handleError"
            :before-upload="beforeUpload"
            :on-change="handleChange"
            :limit="1"
            :file-list="fileList"
            accept=".pdf,.doc,.docx,.xls,.xlsx"
            :auto-upload="true"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传Excel文件，且不超过10MB
            </div>
          </el-upload>
          <div @click="handleClick" class="file-link">{{ form.originalName }}</div>
        </el-form-item>

        <!-- <el-form-item>
          <el-button @click="handleCancel">取消</el-button>
          <el-button type="primary" @click="submitForm" :loading="loading">提交</el-button>
        </el-form-item> -->
      </el-form>
    </div>
  </div>
</template>

<script>
import HeadLable from '@/components/HeadLable/index.vue'
import { getToken } from '@/utils/cookies'
import { saveDocument,queryPrizeDetailsById,updatePrizeDetails } from '@/api/prize.ts'
import { encrypt, decrypt } from '@/utils/crypto'

export default {
  name: 'DocumentUpload',
  components: {
    HeadLable
  },
  data() {
    return {
      title: '导入参赛选手信息',
      titleId: '',
      actionType: '',
      originalName: '',
      form: {
        name: '',
        sort: 1,
        fileUrl: '',
        originalName: '',
        objectName: '',
      },
      rules: {
        // name: [
        //   { required: true, message: '请输入文档名称', trigger: 'blur' },
        //   { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        // ],
        sort: [
          { required: true, message: '请输入排序序号', trigger: 'blur' }
        ]
      },
      fileList: [],
      headers: {},
      headers: {},
      loading: false,
      uploadDisabled: false
    }
  },
  computed: {
    uploadUrl() {
      return `${process.env.VUE_APP_BASE_API}/document/upload/contestant/${this.titleId}`
    },
  created() {
    // 在created钩子中初始化headers
    this.headers = {
      Authorization: getToken()
    };
  },
},
mounted() {
  //   created() {
    //   // 在created钩子中初始化headers
    // };
    this.headers = {
      Authorization: getToken()}
      this.decryptTitleId()
      this.actionType = this.$route.query.id ? 'edit' : 'add';
      console.log(this.actionType);
    if (this.$route.query.id  ) {
      this.title = '修改赛事规则信息'
      this.init()
    }
    },
  methods: {
    beforeUpload(file) {
      const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ]

      const extension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      const isAllowedExtension = ['.xls', '.xlsx'].includes(extension)
      const isAllowedType = allowedTypes.includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isAllowedExtension || !isAllowedType) {
        this.$message.error('只能上传Excel文件!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB!')
        return false
      }

      return true
    },

    // async init() {
    //   queryPrizeDetailsById(this.$route.query.id).then(res => {
    //     console.log(res)
    //     if (res && res.data && res.data.code === 1) {
    //       this.form.fileUrl = res.data.data.context
    //       this.form.originalName = res.data.data.originalName
    //       this.form.name = res.data.data.title
    //       this.form.sort = res.data.data.number
    //     } else {
    //       this.$message.error(res.data.msg)
    //     }
    //   })
    // },
    handleClick() {
      if (this.form.objectName) {
        let Expires = 'competition-competition'
        let keyId = 'LTAI5tNWEVZbouQzvQyUkpLz'
      // Check if the URL is already a complete URL or needs the base API prefix
      const extension = this.form.objectName.split('.').pop().toLowerCase();
      let previewUrl = `http://competition-competition.oss-cn-beijing.aliyuncs.com/${this.form.objectName}`;
      // fullUrl = `http://competition-competition.oss-cn-beijing.aliyuncs.com/documents/041c7e1d-7c01-4550-b996-502efa947c1d.pdf`;

      // 根据文件类型添加特定参数
      // switch(extension) {
      //   case 'pdf':
      //     previewUrl += '&response-content-type=application/pdf';
      //     break;
      //   case 'doc':
      //   case 'docx':
      //     previewUrl += '&response-content-type=application/msword';
      //     break;
      //   case 'xls':
      //   case 'xlsx':
      //     previewUrl += '&response-content-type=application/vnd.ms-excel';
      //     break;
      //   case 'jpg':
      //   case 'jpeg':
      //   case 'png':
      //     previewUrl += '&response-content-type=image/jpeg';
      //     break;
      // }

      // Open in new tab
      window.open(previewUrl, '_blank');
    } else {
      this.$message.warning('没有可查看的文件');
    }
    },
    async init() {
      try {
        const res = await queryPrizeDetailsById(this.$route.query.id)
        if (res.data.code === 1) {
          this.$nextTick(() => {
            this.form.fileUrl = res.data.data.context
            this.originalName = res.data.data.originalName
            this.form.originalName = res.data.data.originalName
            this.form.objectName = res.data.data.objectName
            this.form.name = res.data.data.title
            this.form.sort = res.data.data.number
          })
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    decryptTitleId() {
      try {
        // 解密
        this.titleId = decrypt(this.$route.query.titleId)
      } catch (e) {
        console.error("解密失败:", e)
        // this.title = "默认标题"
      }
    },

    handleChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]
      }
    },

    handleSuccess(response, file, fileList) {
      if (response.code === 1) {
        // this.form.fileUrl = response.data.signedUrl || response.data.url
        // this.form.originalName = file.name
        // this.form.objectName = response.data.objectName
        this.$message.success(response.data)
        this.handleBack()
      } else {
        this.$message.error(response.message || '参赛选手上传失败')
        this.fileList = []
      }
    },

    handleError(err, file, fileList) {
      this.$message.error('文件上传失败: ' + (err.message || '服务器错误'))
      this.fileList = []
    },

    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.form.fileUrl) {
            this.$message.error('请先上传文档文件')
            return false
          }

          this.loading = true

          const params = {
            title: this.form.name,
            number: this.form.sort,
            context: this.form.fileUrl,
            objectName: this.form.objectName,
            originalName: this.form.originalName,
            type: 1,
            titleId: this.titleId
          }
          if (this.actionType == 'add') {
            saveDocument(params).then(res => {
              if (res.data.code === 1) {
                this.$message.success('文档保存成功')
                this.handleBack()
              } else {
                this.$message.error(res.message || '文档保存失败')
              }
            }).catch(err => {
              this.$message.error('请求出错: ' + (err.message || '未知错误'))
            }).finally(() => {
              this.loading = false
            })
          } else {
            params.id = this.$route.query.id
            updatePrizeDetails(params).then(res =>{
              if (res.data.code === 1) {
                this.$message.success('文档修改成功')
                this.handleBack()
              } else {
                this.$message.error(res.message || '文档修改失败')
              }
            }).catch(err => {
              this.$message.error('请求出错: ' + (err.message || '未知错误'))
            }).finally(() => {
              this.loading = false
            })
          }
        }
      })
    },

    handleCancel() {
      this.$confirm('确定要取消上传吗? 所有未保存的内容将会丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleBack()
      }).catch(() => {})
    },

    handleBack() {
      this.$router.push({ path: '/competition/scoreManage', query: { titleId: this.$route.query.titleId, title: this.$route.query.title } })
    }
  }
}
</script>

<style lang="scss" scoped>
.document-upload-container {
  margin: 30px;

  .container {
    background: #fff;
    padding: 30px;
    border-radius: 4px;
    min-height: 500px;

    .el-form {
      max-width: 600px;

      .el-input {
        width: 100%;
      }

      .el-upload {
        display: block;

        &__tip {
          margin-top: 7px;
          color: #909399;
          font-size: 12px;
          line-height: 1.5;
        }
      }
    }
  }
}
.file-link {
  cursor: pointer;
  color: #606266;
  margin-top: 8px;
  display: inline-block;

  // &:hover {
  //   color: #66b1ff;
  // }
}

.file-link:hover {
  color: #409EFF; /* 悬停时变色 */
  text-decoration: underline; /* 悬停时下划线 */
}
</style>
